module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "aria-labelledby": "header0101",
      "epub:type": "chapter",
      "id": "ch01",
      "role": "doc-chapter"
    }
  }, [_c('header', {
    attrs: {
      "id": "header0101"
    }
  }, [_c('h1', {
    staticClass: "cn"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "12",
      "epub:type": "pagebreak",
      "id": "p12",
      "role": "doc-pagebreak"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chicorrigan0006#toc"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('h1', {
    staticClass: "ct"
  }, [_vm._v("Colonial Legacies")])]), _vm._v(" "), _c('section', [_c('h2', {
    staticClass: "ahaft",
    attrs: {
      "id": "ahaft0101"
    }
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p12"
    }
  }), _vm._v("Land and Progress")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_vm._v("The violent attempt to subvert the democratic electoral process that took place at the Capitol on January 6, 2021, attested the conjunction of race, Christianity, and violence in America. Some rioters waved the Confederate flag, which, in the immediately preceding years, had become more explicitly charged with white supremacist intention. Others unfurled Christian banners proclaiming messages such as “Jesus 2020,” “In God We Trust,” and “Jesus and Trump.” One rioter lugged a large wooden cross while others clustered here and there to pray loudly to Jesus. Some in the mob professed anti-Semitic, misogynist, and anti-Asian views. Together they assaulted the Capitol police, causing injury and death in the course of occupying parts of the Capitol. One rioter confronted a Capitol police officer with the words: “Put your gun down and we’ll show you what kind of [n——] you are.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en5",
      "id": "en5r",
      "role": "doc-noteref"
    }
  }, [_vm._v("1")])]), _vm._v(" Texas real estate agent Jenna Ryan, calling for the breaking of the Capitol’s windows, rejoiced when the violence commenced, chanting “U-S-A! U-S-A! Here we are in the name of Jesus!”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en6",
      "id": "en6r",
      "role": "doc-noteref"
    }
  }, [_vm._v("2")])]), _vm._v(" For some, it was “a kind of Christian revolt.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en7",
      "id": "en7r",
      "role": "doc-noteref"
    }
  }, [_vm._v("3")])]), _vm._v(" In the aftermath of the violence, one of the rioters formed a local militia in Virginia to carry on the revolt. Masquerading as a Bible study group, the conspirators met secretly to assemble a large cache of explosives."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en8",
      "id": "en8r",
      "role": "doc-noteref"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', [_vm._v("One of the most visible insurrectionists that day and subsequently the most recognized was Jake Chansley (aka Jake Angeli)."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en9",
      "id": "en9r",
      "role": "doc-noteref"
    }
  }, [_vm._v("5")])]), _vm._v(" Eventually convicted of a felony for his role, the so-called QAnon Shaman stood out against the background of rioters for his costume. In a bearskin headdress with horns, his naked torso and arms tattooed, an exotic-looking amulet around his neck, and American-flag warpaint on his face, and brandishing an American flag mounted on a spear, he struck in unwitting parody the figure of a Native American. Part of his day included praying to Jesus at the dais in the Senate. "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "13",
      "epub:type": "pagebreak",
      "id": "p13",
      "role": "doc-pagebreak"
    }
  }), _vm._v("The Cherokee scholar Joseph Pierce pointed out that while many news bureaus described the costume as “Viking,” in fact, given the context of the riot, it was a condensed symbol of white claims to power that were grounded in colonial violence against Indians. Pierce observed: “I want to emphasize that Angeli is not just attempting to replicate an Indian image, but to live in Indianness as a statement of a right to this place, this country.” Chansley, playing Indian, evinced a sense of primal attachment to Native Americans and their history, and a sense of ownership of the North American landmass that was bound up in that fantasy. But “what he does not realize is that this claim to aboriginal belonging is only possible because of the violent seizure of indigenous lands by the very government that he now protests.” Extending that line of interpretation, Pierce suggested that “storming the Capitol was an expression of the inability to imagine a world in which white people do not automatically and inevitably wield the power over life and death in this country built on genocide and slavery.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en10",
      "id": "en10r",
      "role": "doc-noteref"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', [_vm._v("The terror wrought by Chansley and his criminal cohort instanced an anxiety that was deeply embedded in white American Christianity and that surfaced in violence on January 6. That anxiety was rooted in the long history of the white brutalization of Native Americans and enslaved Africans. Its formation began with European colonization that proclaimed the Americas a New World and progressed as settlers determined to engineer that world with the point of a sword. This book attends to that multilayered history, examining some of its episodes through a lens ground from insights of humanities scholars and scientists. At the center of that discussion is an invitation to think about religion, race, and violence in America by surveying how the lives of white American Christians and those whom they have oppressed are conjoined. The two groups are attached, one to the other. That attachment has been dysfunctional, angst-ridden, and broadly productive of serial violence. It is, as Philip Deloria wrote, a “paradox: The self-defining pairing of American truth with American freedoms rests on the ability to wield power against Indians—social, military, economic, and political—while simultaneously drawing power from them. . . . Intricate relations between destruction and creativity—for both Indian and non-Indian Americans—are suspended in an uneasy alliance.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en11",
      "id": "en11r",
      "role": "doc-noteref"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', [_vm._v("Such dysfunctional attachment is manifest especially in what Americans remember and what they forget. When Pierce ventures that Chansley, fantasizing himself an Indian, cannot remember the white seizure of Indigenous lands, the subsequent genocidal campaigns against Native Americans, and the institutionalized inhumanity of slavery, he is foregrounding the complex processes of cultural memory. Those complex processes are equally perceptible in the case of Anna Morgan-Lloyd, the first criminal sentenced in "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "14",
      "epub:type": "pagebreak",
      "id": "p14",
      "role": "doc-pagebreak"
    }
  }), _vm._v("the January 6 insurrection, who related through her attorney presentencing that she had read Dee Brown’s "), _c('i', [_vm._v("Bury My Heart at Wounded Knee")]), _vm._v(" and felt suddenly informed and remorseful for her role in the attack on the Capitol."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en12",
      "id": "en12r",
      "role": "doc-noteref"
    }
  }, [_vm._v("8")])]), _vm._v(" It was as if she remembered something that she had forgotten. Like Morgan-Lloyd, many other white Americans are haunted by the Wounded Knee Massacre, which wields its power because of its simultaneous absence and presence in memory.")]), _vm._v(" "), _c('p', [_vm._v("American cultural memory, for all Americans, arises from a past of colonial exploitation of the land and its native people and that exploitation’s extension into the present. From the late fifteenth century on, Europeans arrived in America intending to capitalize on its human and natural resources. As vectors of catastrophically lethal disease, outfitted with armored horses and advanced weaponry, and bearing a religious certainty that the land belonged to them, they set about to build their own worlds on the wreckage of those they destroyed. That grim program of requisition extended from the late fifteenth through the nineteenth and early twentieth centuries, and it has remained visible in regularly occurring acts of violence since that time. Just as importantly, having coalesced as structural violence, the vestiges of settler colonialism remain a cogent, albeit often unacknowledged, framework for white exercise of power. That power is felt in social minorities’ experiences of a range of inequalities, in the sequelae of white prosecution of self-interested social and economic agendas.")]), _vm._v(" "), _c('p', [_vm._v("When Scarlett O’Hara pondered her future in the closing scene of the movie "), _c('i', [_vm._v("Gone with the Wind")]), _vm._v(" with the words, “What is there that matters?” she heard the responsive voice of her father. Echoing over the fantasy of a beautiful slave-era South that still informs the fevered dreams of Confederate flag-waving Americans, he answered, “Why, land’s the "), _c('i', [_vm._v("only")]), _vm._v(" thing that matters.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en13",
      "id": "en13r",
      "role": "doc-noteref"
    }
  }, [_vm._v("9")])]), _vm._v(" When a recent historical study expresses the standpoint of many scholars who narrate the American West by “placing Indian lands and nations at the story’s center,”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en14",
      "id": "en14r",
      "role": "doc-noteref"
    }
  }, [_vm._v("10")])]), _vm._v(" it in turn signals a truth about the specifically material power of land that scholars of settler colonialism long have embraced in analyzing colonial pasts worldwide. That is, to speak of settler colonialism is always to speak of land, and to speak of land within a Western discourse is to imply its ownership. Land as property was a commodity bought, sold, traded, taken, and lost. For Europeans, such was the forward movement of history.")]), _vm._v(" "), _c('p', [_vm._v("For the colonial adventurer, land transmissibility and transaction drove history. The forced deliverance of Indian lands into the juridical geographies of settlers acting as agents of the state typically was achieved in obedience to “the concept of empire as a benign and dynamic guarantor of progress.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en15",
      "id": "en15r",
      "role": "doc-noteref"
    }
  }, [_vm._v("11")])]), _vm._v(" That logic of progress underwrote European dispossession of Native "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "15",
      "epub:type": "pagebreak",
      "id": "p15",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Americans. The racially charged principle of progress in land transfers was expressed cogently by General William Tecumseh Sherman in addressing the General Council of the Indian Territory in Ocmulgee, Oklahoma, in 1871: “Two races cannot live together in harmony; the weaker race must give way to the stronger; barbarism in this age of steam and progress must retire before advancing civilization.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en16",
      "id": "en16r",
      "role": "doc-noteref"
    }
  }, [_vm._v("12")])]), _vm._v(" But as Ned Blackhawk has pointed out, Indians such as the Ute initially “remained more than prepared to enter into diplomatic relations with U.S. representatives” over land claims and Indian sovereignties. They “attempted to rein in renegade warriors, to broker and then to uphold teetering agreements, and to convince their people that American promises were not fleeting.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en17",
      "id": "en17r",
      "role": "doc-noteref"
    }
  }, [_vm._v("13")])]), _vm._v(" In other words, the episodes of mass violence that accompanied white settlement of Indian lands were not inevitable.")]), _vm._v(" "), _c('p', [_vm._v("In a rolling series of claims spanning centuries, whites took land for its rich agricultural value, its minerals (especially gold and precious metals), its lumber, its animal life, and the access it provided to fisheries. Whites sometimes took land by destroying its potential to support Indian lives. Black Moon, the Miniconjou Lakota leader, summarized the colonial state of affairs while addressing an assembly of Indians and whites in late June 1867: “The whites are cutting through our territory with their big roads of trade and migration. . . . They shoot our game, and more than they need; they are cruel to our people, abusing and killing them given only the slightest provocation. They cut down our forests in spite of our opposition and without offering us compensation. They are completely ruining our land.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en18",
      "id": "en18r",
      "role": "doc-noteref"
    }
  }, [_vm._v("14")])]), _vm._v(" This was about a century after George Washington had provided the official federal template to Major General John Sullivan on his disembarkment against the Iroquois: “Parties should be detached to lay waste all the settlements around with instructions to do it in the most effectual manner, that the country may not be merely overrun but destroyed.” Washington urged that “it will be essential to ruin their crops in the ground” and effect “the total destruction and devastation of their settlements,” because the national project depended on “the terror with which the severity of the chastisement they receive will inspire [them].”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en19",
      "id": "en19r",
      "role": "doc-noteref"
    }
  }, [_vm._v("15")])])]), _vm._v(" "), _c('p', [_vm._v("Continuing, Black Moon made two statements crucial to understanding relations between Indians and whites in the midst of the violence and rapaciousness that characterized white settlement of the West. For Black Moon, “We were forced against our will to hate the palefaces.” He added, then: “Let us hope, let us spread a blanket over that which has passed, and forget it,” while endeavoring to find a way to live together with whites."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en20",
      "id": "en20r",
      "role": "doc-noteref"
    }
  }, [_vm._v("16")])])]), _vm._v(" "), _c('p', [_vm._v("Suggesting the mingled destinies of whites and Indians, experienced as a sense of connectedness even while hating each other, and proposing that the baleful products of white colonialism be forgotten, Black Moon concisely "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "16",
      "epub:type": "pagebreak",
      "id": "p16",
      "role": "doc-pagebreak"
    }
  }), _vm._v("signaled the core of the paradoxical relationship between colonists and natives. A convoluted affinity bound each side to the other even as they hated and fought, a predicament that both sides tried to forget—for different reasons in each case, but ultimately unsuccessfully in both.")]), _vm._v(" "), _c('p', [_vm._v("The mentality of colonization conflates land with landowner. The taking of Indian lands was accompanied by the taking of Indian lives. The observation that “the question of genocide is never very far from discussions of settler colonialism”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en21",
      "id": "en21r",
      "role": "doc-noteref"
    }
  }, [_vm._v("17")])]), _vm._v(" prompts questions about “the logic of elimination” of the native in settler colonial enterprises,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en22",
      "id": "en22r",
      "role": "doc-noteref"
    }
  }, [_vm._v("18")])]), _vm._v(" and it raises the issue of how that logic was expressed in the rhetoric of colonization. For Chris Mato Nunpa, it was, in short, “the genocidal and imperialistic mind-set present in the Euro-American population.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en23",
      "id": "en23r",
      "role": "doc-noteref"
    }
  }, [_vm._v("19")])]), _vm._v(" And that mindset was not just an artifact of raw calculation about land and its possessors, but about the more complex matters of race and religion as well. As Tiffany Hale notes, manifest destiny is “an explicitly racial concept,” and “beliefs about manifest destiny, providence, civilization, and savagery were . . . profoundly spiritual in nature.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en24",
      "id": "en24r",
      "role": "doc-noteref"
    }
  }, [_vm._v("20")])]), _vm._v(" For Vine Deloria Jr., it boiled down more pointedly to the fact that Christianity was a colonial institution."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en25",
      "id": "en25r",
      "role": "doc-noteref"
    }
  }, [_vm._v("21")])])]), _vm._v(" "), _c('p', [_vm._v("The European settler colonial undertaking in North America, advanced in racial violence warranted by religious rhetoric, produced results that proved for many Americans the philosophical truth of manifest destiny and in so doing fed its ambitions. That project also left fissures, suspicions, and unresolved tensions, until, in time, “at some level, Americans were uneasy about their position as conquerors who had secured assent only through the threat of using extreme violence.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en26",
      "id": "en26r",
      "role": "doc-noteref"
    }
  }, [_vm._v("22")])]), _vm._v(" And that extreme violence was enacted at a great many sites across the continent, and perhaps most vividly, for many Americans, in the tragic occurrence at Wounded Knee in 1890. The experience reported by convicted insurrectionist Anna Morgan-Lloyd in seeking clemency before the court exemplified the popular sense that "), _c('i', [_vm._v("something happened")]), _vm._v(" at Wounded Knee. But her reading could not have informed her of the extent to which the massacre was framed by Christian rhetoric about the necessary extermination of Indigenous peoples to make way for a Christian nation. The 170 men, women, and children cornered and then murdered from a distance by soldiers firing Hotchkiss guns (a small canon firing antipersonnel rounds), on a cold day in late December 1890, long had been essentialized by white religio-political rhetoric as an impediment to divinely ordained white expansion of empire. White misunderstanding of the Ghost Dance ritual, which had become popular among the Sioux that year, contributed to the military escalations that culminated in the slaughter. However, it was the relentless characterization of Native Americans as un-Christian and inferior, and the centuries-long trumpeting of white claims of Christian destiny, that set the "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "17",
      "epub:type": "pagebreak",
      "id": "p17",
      "role": "doc-pagebreak"
    }
  }), _vm._v("frame for what happened on December 29. The Hunkpapa Lakota leader Sitting Bull, who was killed by whites days before the massacre, previously had stated that he “felt the Church was in some way leagued with the U.S. government in crushing the Dakota nationality.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en27",
      "id": "en27r",
      "role": "doc-noteref"
    }
  }, [_vm._v("23")])]), _vm._v(" His sense of the Sioux predicament was clear-eyed and veracious.")])]), _vm._v(" "), _c('section', [_c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ah0101"
    }
  }, [_vm._v("A Religious Enemy")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("The Columbian voyages began a centuries-long war between Euro-Americans and Native Americans that included a long series of atrocities perpetrated by the Spanish, French, English, and Portuguese and, in an attenuated and less systematic way, by Indians. From the time of the onset of hostilities, the machinery of settler colonialism, with its ambition, politics, technology, numbers, and religious inspiration, all but guaranteed that European claims to the space of the Americas would advance in brutal fashion. In North America the English carried with them into conquest a biblically grounded rationale that structured thinking about those encounters as a meeting with a religious enemy.")]), _vm._v(" "), _c('p', [_vm._v("Conflict was present from the beginning. The Virginia Company succeeded in carving out a colonial beachhead at Jamestown in 1607, and within two years the English and Powhatans were fighting. Over the next decade, there were continued frictions, but also enough collaboration with Native Americans initially to inspire a congeries of ostensibly affirmative stories that included the confected tale of an angelic Indian maiden who saved the life of a bold and handsome Englishman. Regardless of whether Pocahontas was real or not, on March 22, 1622, after Indians killed about 350 settlers, things changed. In July of the following year, the English slaughtered a large number of Pamunkeys, and after that, the two sides traded murder for murder for decades.")]), _vm._v(" "), _c('p', [_vm._v("The major Indian wars in New England followed on the heels of the massacres in the Chesapeake. In 1636 the English and their Indian allies began a campaign against the Pequots that reached its fiery apogee in spring 1637 with the burning of between four hundred and seven hundred Indians trapped inside the fortified Indian village of Mystic. Captain John Underhill, widely lauded for his ruthless prosecution of that campaign, shortly thereafter found himself in command of a Dutch force charged with leading two expeditions against Indians around New Amsterdam. His reputation preceding him, he delivered lethal blows to the Indians during Kieft’s War, including a reprise of his tactic at Mystic. In winter 1644 he surrounded an array of wigwams near Stamford, burning as many as 500 Tankitetes and Siwanoys in the fire. In the words of a historian of the war, Underhill, like many of the men who had served with him during the Pequot War, exemplified the emergent theme of "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "18",
      "epub:type": "pagebreak",
      "id": "p18",
      "role": "doc-pagebreak"
    }
  }), _vm._v("serial war with Indians: for soldiers who slaughtered Indians, “violence begets violence.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en28",
      "id": "en28r",
      "role": "doc-noteref"
    }
  }, [_vm._v("24")])])]), _vm._v(" "), _c('p', [_vm._v("And violence followed. Led on the Indian side by Metacom, the subsequent conflict that was named King Philip’s War (1675–78) was the most destructive war in colonial New England. It pitted the Wampanoags and some Narragansetts against an English force of several combined militias and some Indian allies, notably the Mohawks. The losses on both sides were staggering, with many towns and villages destroyed and atrocities throughout. By some reports as much as one-eleventh of able-bodied English males were killed, and the Indian population of southern New England possibly was halved. The English further south meanwhile were battling the Susquehannas, but it was King Philip’s War that struck so deeply into the hearts of New Englanders that it earned the descriptor “The First Indian War.” From the time it was fought, and for generations following, it was, like the Pequot War, a foundational wound for the colonies that became the United States."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en29",
      "id": "en29r",
      "role": "doc-noteref"
    }
  }, [_vm._v("25")])]), _vm._v(" The consequences of the war were “upheaval, destruction, the centuries-long fallout of violence, and ongoing colonialism that haunts everyday habits.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en30",
      "id": "en30r",
      "role": "doc-noteref"
    }
  }, [_vm._v("26")])])]), _vm._v(" "), _c('p', [_vm._v("Without much of a pause after King Philip’s War, Indians were raiding New England towns and colonists were responding, often viciously. Battles likewise continued in other parts of British North America. Bacon’s Rebellion (1676) in Virginia brought more woe to the Pamunkeys, and further south, war with the Yamassees and Tuscaroras (1713) likewise ended badly for the Indians. There was the long Seven Years’ War (1756–63) with the French and their Indian allies. Pontiac’s rebellion (1763–64), spurred in part by the revelations of Neolin, the “Delaware Prophet,” took place on the frontier. More importantly, Pontiac’s rebellion opened the way for the vigilante violence of the Paxton Boys, a large militia in Pennsylvania that roamed freely through some of the colony’s towns, massacring Indians with the intention to “extirpate from earth this Savage race.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en31",
      "id": "en31r",
      "role": "doc-noteref"
    }
  }, [_vm._v("27")])]), _vm._v(" The cold-blooded murder of ninety-eight peaceful Delaware Christians at Gnadenhutten in the Ohio Country in 1782 ordained the descent of the frontier into a fixed pattern of egregious violence against Native Americans.")]), _vm._v(" "), _c('p', [_vm._v("In the nineteenth century that violence increasingly evidenced its genocidal intention."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en32",
      "id": "en32r",
      "role": "doc-noteref"
    }
  }, [_vm._v("28")])]), _vm._v(" The Indian Removal Act (1830) and the consequent Trail of Tears (1830–50) commenced a long series of violent frontier crusades in which Native American men, women, and children were massacred. A partial list of mid-nineteenth-century occurrences includes the Old Shasta Town Massacre (1851), Blue Water Creek Massacre (1855), Spirit Lake Massacre (1857), Jarboe’s War (1859–60), Bear River Massacre (1863), Sand Creek Massacre (1864), Battle of Washita (1868), Marias Massacre (1870), Camp Grant Massacre (1871), Skeleton "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "19",
      "epub:type": "pagebreak",
      "id": "p19",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Cave Massacre (1872), Red River War (1874–75), and Fort Robinson Massacre (1879). Dozens of such massacres took place. Some involved hundreds of deaths. A Christian-flavored ideology of extermination underwrote them, until the Native American population, which had numbered 12–15 million at contact, was reduced—by disease, starvation, and war—to 237,000 by 1900.")]), _vm._v(" "), _c('p', [_vm._v("Emergent U.S. Indian policy rested on the claim that “ ‘wars of extermination’ against resisting Indians were not only necessary but ethical and legal.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en33",
      "id": "en33r",
      "role": "doc-noteref"
    }
  }, [_vm._v("29")])]), _vm._v(" And Christian leaders sometimes took a central role in engineering the violence. John M. Chivington, the ultimately disgraced commander of the force of Colorado Cavalry that killed hundreds of Cheyenne and Arapaho women and children at Sand Creek, was a longtime missionary of the Methodist Church. He had a firsthand appreciation for how whites came to possess the land, and how that possessing abetted the installation of Christianity: “I suppose I was better acquainted in the territory than any man in it at the time. I had been all over it, organized churches, held religious services, appointed ministers and superintended the arrangement of Methodist Church affairs.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en34",
      "id": "en34r",
      "role": "doc-noteref"
    }
  }, [_vm._v("30")])]), _vm._v(" White possession of the land mattered to him, and like other missionaries, he “came to see the violence as a part of God’s redemptive work among Indian nations.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en35",
      "id": "en35r",
      "role": "doc-noteref"
    }
  }, [_vm._v("31")])]), _vm._v(" If it is true that “without religion, the institution of war could not have thrived in American history,”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en36",
      "id": "en36r",
      "role": "doc-noteref"
    }
  }, [_vm._v("32")])]), _vm._v(" Chivington and some of his religious contemporaries on the frontier were foot soldiers in that project.")]), _vm._v(" "), _c('p', [_vm._v("The religious justification of violence against Native Americans was drawn from scriptural passages and other Christian writings. At the outset of the hostilities with Metacom in 1675, with the horror of the Pequot War’s human furnace still fresh in their minds, the New England Confederation had determined to wage war on the Narragansetts by appeal to religion."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en37",
      "id": "en37r",
      "role": "doc-noteref"
    }
  }, [_vm._v("33")])]), _vm._v(" The formal declaration stated that “It clearly appears That God calls the Colonies to a Warr” against an enemy who has joined their tribes together “as of ould Ashur, Amaleck, and the Philistines did confederate against Israel.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en38",
      "id": "en38r",
      "role": "doc-noteref"
    }
  }, [_vm._v("34")])]), _vm._v(" It appears to have been the first time that colonists justified war against Indians with reference to Amalekites, a people who, according to the Old Testament, had harassed and ambushed the Jews in the desert as they made their way to the Promised Land. Identified as kin to the Jews, the Amalekites raided the Jews continuously, until finally God commanded Moses to destroy them: “Now goe, and smite Amalek, and utterly destroy all that they have, and spare them not; but slay both man and woman, infant and suckling, oxe and sheep, camel and asse” (1 Samuel 15:3).")]), _vm._v(" "), _c('p', [_vm._v("The Jews were to exterminate the Amalekites, erasing even memory of them: “I will utterly put out the remembrance of Amalek from under heaven” (Exodus 17:16). But at the same time, “The Lord will have warre with Amalek "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "20",
      "epub:type": "pagebreak",
      "id": "p20",
      "role": "doc-pagebreak"
    }
  }), _vm._v("from generation to generation” (Exodus 17:16). And, crucially, the blotting out was also a remembering: “that thou shalt blot out the remembrance of Amalek from under heaven: thou shalt not forget” (Deuteronomy 25:19)."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en39",
      "id": "en39r",
      "role": "doc-noteref"
    }
  }, [_vm._v("35")])]), _vm._v(" To exterminate but always to have war; to forget but to remember—over centuries that Old Testament message has been parsed by exegetes in many ways, but it has remained an abundantly evocative mixed message, and a compelling guide to understanding memory, violence, and religious power in America. I return to this theme later in the book, exploring in greater depth the crux of what one scholar has broached in discussing the Amalek story in Deuteronomy: “When reconstructing the past, we cannot avoid remembering and at the same time forgetting.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en40",
      "id": "en40r",
      "role": "doc-noteref"
    }
  }, [_vm._v("36")])])]), _vm._v(" "), _c('p', [_vm._v("The historian of antiquity Jan Assmann has argued that monotheism as a worldview supplied the creeping motivation for religious violence by establishing the practice of fierce denunciations of other religions."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en41",
      "id": "en41r",
      "role": "doc-noteref"
    }
  }, [_vm._v("37")])]), _vm._v(" Historians of monotheism have well documented how, additionally, such denunciations typically are most vehement when leveled against heretical groups, groups that can appear to be religious kin but are perceived as having turned against the consensus truths of orthodox belief. When religion and race intersect, the situation becomes more complex, but the core principle of kin endures as a component of religiously legitimated violence. It may be the case that “different people are hated and feared, but the timely antipathy against them is nothing compared to the hatreds turned toward the greater menace of the half-different and the partially familiar,” who constitute a primal threat to “the tidy, bleached out zones of impossibly pure culture.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en42",
      "id": "en42r",
      "role": "doc-noteref"
    }
  }, [_vm._v("38")])]), _vm._v(" Roman Catholics and Mormons were pictured in something like those terms by white Protestant Christians through much of American history. Roman Catholics, Mormons, and Protestants, along with other religious groups, all pictured Native Americans in that way from the beginnings of their encounters with them."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en43",
      "id": "en43r",
      "role": "doc-noteref"
    }
  }, [_vm._v("39")])])]), _vm._v(" "), _c('p', [_vm._v("Before identifying the Indians as Amalekites, English Protestants had identified Roman Catholics that way. Catholics in England were Christian; that is, they were religious kin. But they differed as well, in a traitorous way. Conflict with Catholics was religious conflict, and English Protestants typically cited the story of the Amalekites with its justification of extermination in ongoing rhetorical jousts—and during some periods of violence—with English Catholics."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en44",
      "id": "en44r",
      "role": "doc-noteref"
    }
  }, [_vm._v("40")])]), _vm._v(" But once inserted into the conflict with Indians, the story became a standard way of characterizing the constant wars. Captain Samuel Appleton, a commander of the forces arrayed against the Narragansetts in 1675, wrote to a friend: “By the prayers of God’s people, our Israel in his time may prevail over this cursed Amalek; against whom I believe the Lord will have war forever until he have destroyed him.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en45",
      "id": "en45r",
      "role": "doc-noteref"
    }
  }, [_vm._v("41")])]), _vm._v(" In 1689, preaching to soldiers "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "21",
      "epub:type": "pagebreak",
      "id": "p21",
      "role": "doc-pagebreak"
    }
  }), _vm._v("setting off to fight Indians, Cotton Mather exhorted them, “Turn not back until they are consumed.” He advised: “Tho’ they Cry; let there be none to save them; But beat them small as the Dust before the Wind.” We pray, he said, for “vengeance . . . against the Amalek that is now annoying this Israel in the wilderness.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en46",
      "id": "en46r",
      "role": "doc-noteref"
    }
  }, [_vm._v("42")])]), _vm._v(" In relating details of the “fight at Piggwacket” in 1725, Rev. Thomas Symmes sermonized that Captain John Lovewell, who lost his life, the battle, and a majority of his force while bounty-hunting Indian scalps, resembled Joshua, Moses’s “renowned general, in his wars with the Aborigines of Canaan,” the Amalekites."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en47",
      "id": "en47r",
      "role": "doc-noteref"
    }
  }, [_vm._v("43")])])]), _vm._v(" "), _c('p', [_vm._v("Jonathan Edwards, Charles Grandison Finney, Alexander Campbell, Ellen Gould White, Robert Louis Dabney, and many other religious and civil leaders of the eighteenth and nineteenth centuries wrote and preached about the Amalekites and their erasure. By the mid-nineteenth century, historians and journalists took it as a commonplace that Euro-Americans justified their wars against the Indians as an extermination modeled after the Jews’ destruction of the Amalekites. "), _c('i', [_vm._v("Putnam’s Magazine")]), _vm._v(" observed in 1857 that Christians in colonial North America treated Indians “as the Amalekites and Canaanites had been treated by the Hebrews.” George Bancroft, in his monumental "), _c('i', [_vm._v("History of the United States")]), _vm._v(", discerned that New Englanders assumed that they had “a right to treat the Indians on the footing of Canaanites or Amalekites.” The "), _c('i', [_vm._v("North American Review")]), _vm._v(", remarking on seventeenth-century English encounters with Indians in the Northeast, concluded: “Heathen they were in the eyes of the good people of Plymouth Colony, but nations of heathen, without question, as truly were the Amalekites.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en48",
      "id": "en48r",
      "role": "doc-noteref"
    }
  }, [_vm._v("44")])])]), _vm._v(" "), _c('p', [_vm._v("King Philip’s War in the 1670s remained a profoundly formative experience for New Englanders and their descendants through the middle of the nineteenth century and beyond. It was a catastrophe that shaped identity."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en49",
      "id": "en49r",
      "role": "doc-noteref"
    }
  }, [_vm._v("45")])]), _vm._v(" But in America in retrospect it was the slaughter at “Mystick” in 1637 that increasingly came to the forefront of discussion about triumph and atrocity in war with the Indians. Edward Eggleston looked back in 1883 on the “scenes of savage cruelty” at Mystic in 1637, an atrocity, he added, that was so appalling to some of the English soldiers that “even the citation of Joshua’s destruction of the Canaanites could not allay” their revulsion. Eggleston, like many other commenters, presumably had read veteran Major John Mason’s "), _c('i', [_vm._v("Brief History of the Pequot War")]), _vm._v(", which Thomas Prince had published in 1736 and which was republished in the late nineteenth century in a collection with several other accounts of the war edited by the Ohioan Charles Orr. Mason exulted: “Our Mouths were filled with Laughter and our Tongues with Singing.” The delivery of the faithful to victory was plain: “Was not the Finger of God in all of this?”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en50",
      "id": "en50r",
      "role": "doc-noteref"
    }
  }, [_vm._v("46")])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "22",
      "epub:type": "pagebreak",
      "id": "p22",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Mystic was, as historian Bernard Bailyn wrote, “holy war.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en51",
      "id": "en51r",
      "role": "doc-noteref"
    }
  }, [_vm._v("47")])]), _vm._v(" It was a battle, recalled Rev. Thomas Shepard of Cambridge, in which the English triumphed because of their Christian faith: “the Providence of God guided them to . . . the divine slaughter.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en52",
      "id": "en52r",
      "role": "doc-noteref"
    }
  }, [_vm._v("48")])]), _vm._v(" And the spectacle of human agony indeed was biblical. Captain John Underhill, one of the leaders of the attack on Mystic, reported that the greener soldiers blanched at how “great and doleful was the bloody sight . . . to see so many souls lie gasping on the ground, so thick, in some places, that you could hardly pass along.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en53",
      "id": "en53r",
      "role": "doc-noteref"
    }
  }, [_vm._v("49")])]), _vm._v(" The Indian allies of the English, said Underhill, cried out that the burning of the Pequot was no good, because “it is too furious and slays too many men.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en54",
      "id": "en54r",
      "role": "doc-noteref"
    }
  }, [_vm._v("50")])]), _vm._v(" When "), _c('i', [_vm._v("The Living Age")]), _vm._v(" in 1871 observed of the slaughter, “As the Israelites slew the Amalekites, so did the Pilgrims slay the Pequot,” it was signaling a barely thinkable catastrophe, “the conflagration at Mystick,” that nevertheless had taken up deep residence in American memory."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en55",
      "id": "en55r",
      "role": "doc-noteref"
    }
  }, [_vm._v("51")])])]), _vm._v(" "), _c('p', [_vm._v("Extermination of the Indians, a religiously justified undertaking, could take on the character of an ethical duty. Even for the explorer Peter Skene Ogden (from a family relocated from Long Island to Canada), who explored the American West and married a Nez Perce woman, Christianity and genocide ran together. He reported in the journal of his Snake River expedition of 1827–1828: “I would willingly sacrifice a year or two to exterminate the whole Snake tribe, women and children excepted. In so doing I could fully justify myself before God and man.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en56",
      "id": "en56r",
      "role": "doc-noteref"
    }
  }, [_vm._v("52")])]), _vm._v(" Justification soon overlapped with motive. And as the religious framing of war with Indians became a "), _c('i', [_vm._v("doxa")]), _vm._v(", “exterminate” and “extirpate,” in reference to Indians, became shorthand for the religiously inspired erasure of North American Amalekites."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en57",
      "id": "en57r",
      "role": "doc-noteref"
    }
  }, [_vm._v("53")])])]), _vm._v(" "), _c('p', [_vm._v("In early colonial America, the term "), _c('i', [_vm._v("extirpate")]), _vm._v(" was deployed largely in writing that referred to religious enemies, as in Cotton Mather’s discussion of the French Royalist attempts to extirpate the Waldenses in the sixteenth and seventeenth centuries."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en58",
      "id": "en58r",
      "role": "doc-noteref"
    }
  }, [_vm._v("54")])]), _vm._v(" By the early nineteenth century, according to one observer, those who advocated extermination were impelled by “the doctrine they heretofore had held, viz.: that the Indians were the Canaanites, who by God’s commandment were to be destroyed.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en59",
      "id": "en59r",
      "role": "doc-noteref"
    }
  }, [_vm._v("55")])]), _vm._v(" Indeed, in some cases Indians were thought to be actual descendants of the Canaanites—the Lost Tribes myth still holding sway in the nineteenth century"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en60",
      "id": "en60r",
      "role": "doc-noteref"
    }
  }, [_vm._v("56")])]), _vm._v("—and therefore a deserving target, “under the idea that they were the descendants of the Canaanites, who, by God’s commandment, were to be cut off from the face of the earth.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en61",
      "id": "en61r",
      "role": "doc-noteref"
    }
  }, [_vm._v("57")])]), _vm._v(" When, in a gallows speech in 1766, the Indian murderer James Anen confessed that “he thought it a duty to extirpate the Heathen,” he borrowed from the circulating notion of extirpation as a specifically religious duty."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en62",
      "id": "en62r",
      "role": "doc-noteref"
    }
  }, [_vm._v("58")])]), _vm._v(" When Henry Knox, the first U.S. secretary of war, ordered a 2,000-strong federal "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "23",
      "epub:type": "pagebreak",
      "id": "p23",
      "role": "doc-pagebreak"
    }
  }), _vm._v("force into the Ohio country to punish the Wabash for their attacks on settlers, authorizing that force to “extirpate, utterly” the Wabash and other nations who were impeding settlement, his thinking, too, had been shaped by a religious logic that advocated “conquering those Philistines [i.e., people of Canaan] who have come up against us.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en63",
      "id": "en63r",
      "role": "doc-noteref"
    }
  }, [_vm._v("59")])])]), _vm._v(" "), _c('p', [_vm._v("Historian Jeffrey Ostler, in his detailed chronicling of the use of the term "), _c('i', [_vm._v("extirpate")]), _vm._v(", discussed how Thomas Jefferson thought extirpation a policy option, and how persons throughout government embraced it, and especially so as settlers moved westward."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en64",
      "id": "en64r",
      "role": "doc-noteref"
    }
  }, [_vm._v("60")])]), _vm._v(" General Sherman, writing President Grant from the frontier, accordingly urged that “we must act with vindictive earnestness against the Sioux, even to their extermination, men, women, and children.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en65",
      "id": "en65r",
      "role": "doc-noteref"
    }
  }, [_vm._v("61")])]), _vm._v(" Americans, said a writer in 1876, had set a course “to pursue them with exterminating vengeance.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en66",
      "id": "en66r",
      "role": "doc-noteref"
    }
  }, [_vm._v("62")])]), _vm._v(" And it was with faith in a divinely ordained scheme of things that General Jeffrey Amherst wrote to Henry Bouquet in 1763 to “try Every other method, that can serve to extirpate this execrable race.—I should be very glad your Scheme for Hunting them down like Dogs could take Effect.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en67",
      "id": "en67r",
      "role": "doc-noteref"
    }
  }, [_vm._v("63")])]), _vm._v(" Americans, said a Topeka newspaper, made a prayer of it: “a set of miserable, dirty, lousy, blanketed, thieving, lying, smoking, murdering, graceless, faithless, gut-eating skunks . . . whose immediate and final extermination all men, except Indian agents and traders, should pray for.” Indians were “the secret Enemy of Christ.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en68",
      "id": "en68r",
      "role": "doc-noteref"
    }
  }, [_vm._v("64")])]), _vm._v(" Or perhaps they were not so secret. William Hubbard, author of "), _c('i', [_vm._v("A Narrative of the Troubles with the Indians in New England")]), _vm._v(", had scrutinized the behavior of the Indians in 1677 and discovered “hatred of our Religion therein revealed.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en69",
      "id": "en69r",
      "role": "doc-noteref"
    }
  }, [_vm._v("65")])])]), _vm._v(" "), _c('p', [_vm._v("In the record of violence against Indians, there is genocide, and it was plainly obvious to Indians as well as to those who prosecuted it."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en70",
      "id": "en70r",
      "role": "doc-noteref"
    }
  }, [_vm._v("66")])]), _vm._v(" But the nature of relations between Indians and Euro-Americans was, as D. H. Lawrence suggested in 1923, always paradoxical: “There has been, all the time, in the white American soul, a dual feeling about the Indian. . . . The desire to extirpate the Indian. And the contradictory desire to glorify him. Both are rampant still, today.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en71",
      "id": "en71r",
      "role": "doc-noteref"
    }
  }, [_vm._v("67")])]), _vm._v(" Historically there has been a dysfunctional attachment between Native Americans and Euro-Americans. Dysfunctional attachment as a concept that appears in psychological research offers some advantages for analysis when applied to the study of social groups."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en72",
      "id": "en72r",
      "role": "doc-noteref"
    }
  }, [_vm._v("68")])]), _vm._v(" Social groups can be said to be dysfunctionally attached when they are relationally situated to each other in a way that discloses both the connections between them—the shared norms, ideas, experiences, and goals—and the differences that cause friction between them. In some cases, there are feelings of connectedness alongside feelings of fear and distrust, a sense of kinship alongside a sense of oppositeness. Dysfunctional attachment can manifest in various ways. In American "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "24",
      "epub:type": "pagebreak",
      "id": "p24",
      "role": "doc-pagebreak"
    }
  }), _vm._v("history, the dysfunctional attachment between Native Americans and Euro-Americans manifested, at one level, as haunting."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en73",
      "id": "en73r",
      "role": "doc-noteref"
    }
  }, [_vm._v("69")])]), _vm._v(" And there have been other manifestations, including ongoing structural violence against Indians.")])]), _vm._v(" "), _c('section', [_c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ah0102"
    }
  }, [_vm._v("The Colonial Present")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("In 1960 the UN General Assembly’s “Declaration on the Granting of Independence to Colonial Countries and Peoples” condemned colonialism as the “subjection of peoples to alien subjugation, domination and exploitation” and to “a denial of fundamental human rights.” It likewise ratified economic self-determination, political sovereignty, and cultural freedom for all social and governmental communities."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en74",
      "id": "en74r",
      "role": "doc-noteref"
    }
  }, [_vm._v("70")])]), _vm._v(" Such a resolution might suggest that there is such a thing as a colonial past that can recede into invisibility. Like all legal or paralegal pronouncements concerned with social justice, it bespeaks a certain amount of reification of social processes in the depiction of colonialism as an event, a point located on a historical line, which is given shape by jurisprudential reasoning and consigned to a prison of its own toxic moment of historical occurrence.")]), _vm._v(" "), _c('p', [_vm._v("But there is a colonial present as well as a colonial past. And that colonial present powerfully shapes the social possibilities (including the attendant material and psychological statuses) for peoples who grappled directly with the vicious tactics of colonization when the project of settlement was explicit and broadly acknowledged. The colonial present follows on that. It is a structural colonialism that survives in the aftermath of the official closing of the frontier and the resettlement of indigenes. Its pernicious effects are why Waziyatawin Angela Wilson seeks to “wake people up to the extent to which colonization and oppression of Dakota People are ongoing, even in our ancient homeland.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en75",
      "id": "en75r",
      "role": "doc-noteref"
    }
  }, [_vm._v("71")])])]), _vm._v(" "), _c('p', [_vm._v("One way of glimpsing the machinery that sustains the colonial present is to consider the simple material aftermath of the Wounded Knee Massacre, in which the ongoing dispossession of Sioux land punctuated the insatiability of imperial ambition. As much as Americans imagined the massacre as a closure of the conflict between whites and Indians, rendering Native Americans as “ghosts that haunt the American mind,” the Indian did not disappear. Nevertheless, the “long sentence of pain and dispossession” continued even as Indians demonstrated resilience and skill in adapting to new circumstances."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en76",
      "id": "en76r",
      "role": "doc-noteref"
    }
  }, [_vm._v("72")])]), _vm._v(" The Dawes Act of 1887 ensured that land transfer from Native Americans to whites would continue in a steady stream of transactions, so that in the half century following Dawes, Indian land holdings dropped from 138 million acres to 48 million."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en77",
      "id": "en77r",
      "role": "doc-noteref"
    }
  }, [_vm._v("73")])]), _vm._v(" In 2013, the white owner of the site of the massacre itself "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "25",
      "epub:type": "pagebreak",
      "id": "p25",
      "role": "doc-pagebreak"
    }
  }), _vm._v("placed it on the market for an asking price of $4.9 million, pointedly demonstrating the intersectionality of market capitalism and dispossession in the colonial present."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en78",
      "id": "en78r",
      "role": "doc-noteref"
    }
  }, [_vm._v("74")])])]), _vm._v(" "), _c('p', [_vm._v("Such land dispossession is one aspect of structural violence that is common to postcolonial societies, taking a variety of forms along a spectrum of material and psychological manifestations. Those range from actual state policies, as, for example, in Argentina,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en79",
      "id": "en79r",
      "role": "doc-noteref"
    }
  }, [_vm._v("75")])]), _vm._v(" to insidious processes of identity erasure, as in Rwanda,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en80",
      "id": "en80r",
      "role": "doc-noteref"
    }
  }, [_vm._v("76")])]), _vm._v(" or in the United States, where the nineteenth-century call to erase Indian identity (“Kill the Indian, save the man”) was carried forward structurally into succeeding generations by the Indian boarding school system, characterized by David Treuer as “federally funded religious schools.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en81",
      "id": "en81r",
      "role": "doc-noteref"
    }
  }, [_vm._v("77")])]), _vm._v(" The endgame of the North American boarding schools as a colonialist machinery was, according to one scholar, not difficult to envision: “U.S. boarding schools for Indians had a hidden agenda: stealing land.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en82",
      "id": "en82r",
      "role": "doc-noteref"
    }
  }, [_vm._v("78")])]), _vm._v(" That judgment fits into a broader picture of the means of subjugation of peoples in colonized spaces in Africa and elsewhere."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en83",
      "id": "en83r",
      "role": "doc-noteref"
    }
  }, [_vm._v("79")])]), _vm._v(" Regardless of the forms it takes, such a colonial heritage is rooted in a fantasy that colonization has ended, and that the violence of colonialism accordingly is no more. And with that fantasy come the various processes of obscuration, including disavowals of violence in the past.")]), _vm._v(" "), _c('p', [_vm._v("So, for example, the long history of conflicts between whites and Indians is not a part of a popular founding story about America. There is no popular lesson of struggle and redemption. With respect to the violence of colonial encounter, white Americans “prefer to contain it within the category of ‘Indian wars,’ rather than allow it to infect the grand narratives of the American Iliad.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en84",
      "id": "en84r",
      "role": "doc-noteref"
    }
  }, [_vm._v("80")])]), _vm._v(" And this is not to mention the deep shadow cast over the history of Indian wars by the Civil War memory industry.")]), _vm._v(" "), _c('p', [_vm._v("Such suppression is equally apparent in the construction of Native Americans as a “vanishing race,”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en85",
      "id": "en85r",
      "role": "doc-noteref"
    }
  }, [_vm._v("81")])]), _vm._v(" a rhetorical turn that effectively belies the legacies of colonial violence against Native Americans. Such adumbrations frustrate understanding of the enduring structural violence of colonialism, which effects material inequalities, legal injustices, and cultural dislocations, and is manifested especially as “environmental racism and ecological genocide.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en86",
      "id": "en86r",
      "role": "doc-noteref"
    }
  }, [_vm._v("82")])]), _vm._v(" Glen Coultard, reflecting on the policy consequences of that sleight-of-hand, writes that “if there is no colonial present . . . but only a colonial past that continues to have adverse effects on Indigenous people and communities, then the federal government need not take the actions to transform the current institutions and social relationships that have been shown to produce the suffering we see . . . across Indigenous communities today.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en87",
      "id": "en87r",
      "role": "doc-noteref"
    }
  }, [_vm._v("83")])]), _vm._v(" In other words, the adverse effects of colonialism are not a reified legacy, an inherited illness that sickens the descendants of those who originally contracted it. They are much "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "26",
      "epub:type": "pagebreak",
      "id": "p26",
      "role": "doc-pagebreak"
    }
  }), _vm._v("more than that. They have become a condition of the present induced by enduring schemata that are active, dynamic, and continuous.")]), _vm._v(" "), _c('p', [_vm._v("Indians built empires in North America. They conquered and subjugated tribes with whom they competed for resources, they practiced slavery, they fashioned geographically expansive cultures, and they battled colonizing Euro-Americans for land rights and natural resources. Accordingly, they also played a central role in the development of the empire built by those settler-colonists, by participating substantially in the forging of the economies, politics, material culture, and lifeways of what was to become America."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en88",
      "id": "en88r",
      "role": "doc-noteref"
    }
  }, [_vm._v("84")])])]), _vm._v(" "), _c('p', [_vm._v("But unlike the case in many other regions of the world where Europeans established colonial presences, settler colonialism in what became the United States did not offer the possibility for decolonizing gestures because the European settlers retained power. In the extractive colonialism in South Asia, South America, and parts of Africa—represented vividly by the mines in the Belgian Congo and the Dutch sugar operations in Java—decolonization amounted to a loss of the colony, notwithstanding ongoing European influence, and one that could be catastrophic for investors, brokers, settlers, and governments’ dreams. In British colonies in North America, Australia, and New Zealand, there was no gesture of decolonization, no postcolonial moment to fix in narrative. There was instead permanent dislocation of indigenes and little motive to negotiate new relationships with them. In settler-descended nations such as the United States, then, “as a result, the structures, and structural violence, of settler colonialism continue to dominate the lived experience of Indigenous populations.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en89",
      "id": "en89r",
      "role": "doc-noteref"
    }
  }, [_vm._v("85")])])]), _vm._v(" "), _c('p', [_vm._v("Certainly there is, to use a term popularized by Achille Mbembe, a "), _c('i', [_vm._v("postcolony")]), _vm._v(" experience of ongoing social and political decomposition and violence in states that were not established as settler colonial projects."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en90",
      "id": "en90r",
      "role": "doc-noteref"
    }
  }, [_vm._v("86")])]), _vm._v(" There are structural lineages that worsen the predicament of Indigenous populations in such places just as there are in Australia or the United States. But the character of the ongoing violence differs in some ways, and not least in that the ordeal of Indigenous peoples in settler colonial–descended states such as the United States is a constant witness to the brutality of the colonizer who now holds power as resident ruler.")])]), _vm._v(" "), _c('section', [_c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ah0103"
    }
  }, [_vm._v("Resilience")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Native Americans who escaped the exterminating angel of American imperialism invented ways in which to move forward as communities while located in uneasy relationships with whites. A striking instance of survival of Native American worldviews and cultures is the recent history of precisely that place "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "27",
      "epub:type": "pagebreak",
      "id": "p27",
      "role": "doc-pagebreak"
    }
  }), _vm._v("where white Americans previously had pronounced their requiems for Native American ways of life. The dramatic two-month occupation of the Wounded Knee site, on the Pine Ridge reservation, by a group of Oglala Lakotas and members of the American Indian movement in 1973 evidenced the durability and determination of a Native American culture that many Americans believed had passed into historical obscurity.")]), _vm._v(" "), _c('p', [_vm._v("Wounded Knee subsequently became a symbol of Native American resistance and activism, inspiring other movements in the decades since. A central component of that resistance has been the Native American struggle to gain control of public narratives about their history. One such illustrative instance, which represents a broader array of events, involved the statue of the Spanish conquistador Juan de Onate that was installed at a New Mexico Heritage Center in Alcade in 1994. Onate, who led the Spanish colonization and oversaw the Catholic indoctrination of the Pueblos and other native peoples in the region, commissioned the military action that led to the massacre in 1599 of hundreds of Acomas, including 300 women and children. Ongoing protests from the Keres Acoma Nation and other native communities led to the removal of the statue in 2020. Native American resistance likewise forced the removal of a large statue of Onate in Albuquerque that same year, from a site that already had been undergoing transformation since installation there in 2005 of Nora Naranjo Morse’s landscape sculpture "), _c('i', [_vm._v("Numbe Whageh")]), _vm._v(" (Our Center Place). In a United States that has become increasingly dialed in to the meanings of monuments—a “memorial mania” according to one writer"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en91",
      "id": "en91r",
      "role": "doc-noteref"
    }
  }, [_vm._v("87")])]), _vm._v("—and in a parlous and dug-in political environment where battles for control of national narratives rage, Native Americans in these instances prevailed. Four hundred years after the Acoma massacre, Onate and his horse were vanquished.")]), _vm._v(" "), _c('p', [_vm._v("The persistence of Native Americans in surviving and resisting—what Gerald Vizenor has called “survivance,” a “sense of native presence and actuality over absence, nihility, and victimry”—echoes in the words of Indian leaders over centuries."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en92",
      "id": "en92r",
      "role": "doc-noteref"
    }
  }, [_vm._v("88")])]), _vm._v(" That persistence is founded in an Indian determination to refuse objectification as victim and to insist on recognition as complexly human. In 1879, Chief Standing Bear, the leader of a small band of Poncas (whose own statue was unveiled in the U.S. Capitol in 2019), stood before the judge in his trial and in the course of a moving speech asserted: “I am a man.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en93",
      "id": "en93r",
      "role": "doc-noteref"
    }
  }, [_vm._v("89")])]), _vm._v(" The judge in the case, who had wept at Standing Bear’s words, subsequently agreed “That an Indian is a "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("PERSON")]), _vm._v(" within the meaning of the laws of the United States,” and thus eligible to sue the state."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en94",
      "id": "en94r",
      "role": "doc-noteref"
    }
  }, [_vm._v("90")])]), _vm._v(" That it took such an exercise to secure the freedom of Standing Bear and his people bespeaks not only the enduring power of the racist and colonialist mentality "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "28",
      "epub:type": "pagebreak",
      "id": "p28",
      "role": "doc-pagebreak"
    }
  }), _vm._v("that necessitated the trial,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en95",
      "id": "en95r",
      "role": "doc-noteref"
    }
  }, [_vm._v("91")])]), _vm._v(" but equally the “survivance” of Native Americans who had been fighting for such recognition for generations."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en96",
      "id": "en96r",
      "role": "doc-noteref"
    }
  }, [_vm._v("92")])])]), _vm._v(" "), _c('p', [_vm._v("What Joseph M. Marshall calls “the art of perseverance” among Native Americans is visible in a multitude of ways throughout North American history,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en97",
      "id": "en97r",
      "role": "doc-noteref"
    }
  }, [_vm._v("93")])]), _vm._v(" including in continuities in archaeological evidence."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en98",
      "id": "en98r",
      "role": "doc-noteref"
    }
  }, [_vm._v("94")])]), _vm._v(" North American history was not “made by white people and done to Indian people.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en99",
      "id": "en99r",
      "role": "doc-noteref"
    }
  }, [_vm._v("95")])]), _vm._v(" That history was made together, albeit between parties in a dysfunctional relationship, because of Indian persistence.")]), _vm._v(" "), _c('p', [_vm._v("Indians survived by adaptation. As in all colonial contexts, there was hybridity. But Native American cultures, “dynamic, pluralistic, and enduring,”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en100",
      "id": "en100r",
      "role": "doc-noteref"
    }
  }, [_vm._v("96")])]), _vm._v(" often held their own in negotiating terms of adaptation, informed by what Ella C. Deloria called “a native shrewdness in meeting new conditions.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en101",
      "id": "en101r",
      "role": "doc-noteref"
    }
  }, [_vm._v("97")])]), _vm._v(" And they were braced as well by a deliberating approach to cultural change: “Traditions die hard and innovation comes hard. Indians have survived for thousands of years in all kinds of conditions. They do not fly from fad to fad seeking novelty. That is what makes them Indian.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en102",
      "id": "en102r",
      "role": "doc-noteref"
    }
  }, [_vm._v("98")])]), _vm._v(" Western theories about the consequences of mass violence, about genocide and especially as it has occurred in Africa, Australia, New Zealand, and the Americas, tend to “neglect the agency, resistance, resilience, and creativity” of peoples who have suffered that violence."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en103",
      "id": "en103r",
      "role": "doc-noteref"
    }
  }, [_vm._v("99")])]), _vm._v(" Theory, for example, that has diagnosed the late colonial and postcolonial condition depicted in Aboriginal and Maori literature has missed the point when characterizing that condition as “a serious ailment when in fact it has given birth to strong-lived visions of cultural recuperations.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en104",
      "id": "en104r",
      "role": "doc-noteref"
    }
  }, [_vm._v("100")])]), _vm._v(" That recuperative agency and resilience are most visible in how Indigenous peoples negotiate the practicalities of survival, the requirements for staying alive, protecting family and community, and communicating ideas and feelings. There has been a pragmatism to Native American adaptation.")]), _vm._v(" "), _c('p', [_vm._v("Pragmatism underlay, for example, the Plains Indians’ development from scratch of a horse culture. Reintroduced to North America by Europeans after becoming extinct about the time of the Ice Age, the horse was bred, trained, and exploited—most impressively by the Comanches—to enable Indians to compete more efficaciously with Europeans for resources. In North America, and “in the Plains in particular, tribes showed supreme adaptability, resourcefulness, and creative syncretization. They took what Europeans had and made it wholly their own.” In this process of pragmatic negotiation, “the horse was the key,” and facilitated a “renaissance in Plains cultures.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en105",
      "id": "en105r",
      "role": "doc-noteref"
    }
  }, [_vm._v("101")])]), _vm._v(" The broader cultural resonances of that pragmatism and persistence are redolent in a wide range of Indian literatures, material culture, and political organization. Writers such as Louise Erdrich, Sherman Alexie, N. Scott Momaday, Leslie Silko, and Nora Marks Dauenhauer have foregrounded it, and they, "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "29",
      "epub:type": "pagebreak",
      "id": "p29",
      "role": "doc-pagebreak"
    }
  }), _vm._v("along with many other Native American writers, have braided it with commentary about healing and spirituality."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en106",
      "id": "en106r",
      "role": "doc-noteref"
    }
  }, [_vm._v("102")])])]), _vm._v(" "), _c('p', [_vm._v("Some of the most striking examples of adaptation are found in religion. For the Lakotas, engagements with Roman Catholicism were complex and enduring. Lakotas drew on the social and political infrastructures of the Catholic missions to organize resistance to land theft by whites, to cobble economic support for communities that were severely disadvantaged, and to keep their families intact. But Sicangu Lakota digestion of Catholic missionizing on the Rosebud reservation in South Dakota amounted to a restatement of Catholic doctrines and rituals “in terms of basic categories of Lakota thought and ritual.” In general, Sicangus adopted “various forms of the ‘white man’s prayer’ in purely utilitarian terms.” Some converted to Catholicism while secretly holding fast to Sicangu religious tradition, while others displayed more openly their ambiguous connections with Catholic orthodoxy by pursuing their own, customized relationships with Catholic spiritual powers. Give-and-take was ongoing until Sicangus burned down the mission in 1916."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en107",
      "id": "en107r",
      "role": "doc-noteref"
    }
  }, [_vm._v("103")])])]), _vm._v(" "), _c('p', [_vm._v("The case was largely the same with the Kiowas in the latter part of the nineteenth century. They also drew options from newly introduced white inventories of spiritual practices and belief in seeking a pathway to survive in the midst of drastic changes to their way of life."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en108",
      "id": "en108r",
      "role": "doc-noteref"
    }
  }, [_vm._v("104")])]), _vm._v(" For many Indians, religion, in short, was a means of locating and capitalizing on spiritual, material, and cultural resources that would enhance the likelihood of survival. It often was a contest of competing spiritual visions. But, as David Martinez writes, “The conflict between Christianity and Indian religions was, on the one hand, a battle for America’s soul, while, on the other, it forged a new identity for tribes seeking ways to endure as tribal peoples.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en109",
      "id": "en109r",
      "role": "doc-noteref"
    }
  }, [_vm._v("105")])])]), _vm._v(" "), _c('p', [_vm._v("Religious hybridity was especially obvious in the Ghost Dance, a ritual practiced most notably by Plains Indians and also by other tribes further west and south. Christian symbology, linguistic and material, was interwoven in the dance. Its performance expressed Native American anxieties about cultural change, hope for the future, and a sense of connectedness with, but also distance from, the U.S. government. It was partly a religious response to colonialism, an enactment of the suffering brought by colonialism but at the same time a display of adaptation and persistence. The Ghost Dance, like other religious practices, was a “central medium” through which defiance was expressed and assimilation contested."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en110",
      "id": "en110r",
      "role": "doc-noteref"
    }
  }, [_vm._v("106")])]), _vm._v(" The U.S. government and many white settlers found it threatening for its seemingly millenarian orientation as well as because of its growing popularity among the Lakotas. Such fears led to the Wounded Knee Massacre in winter 1890.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "30",
      "epub:type": "pagebreak",
      "id": "p30",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Historical lessons regarding the Ghost Dance and Wounded Knee include the central place of spiritual concerns in Lakota life and the fraught process of cultural amalgamation, but especially the example of persistence and survival. The massacre at Wounded Knee has long served in public imagination as the quintessential witness to the bloody vindictiveness of the settler colonial venture in North America. It became, for many Americans, “a touchstone of Indian suffering, a benchmark of American brutality, and a symbol of the end of Indian life, the end of the frontier.” But it was also “the beginning of modern America” and the beginning of a path on which Native Americans embarked with a determination to remain vital and engaged. “Wounded Knee, in other words, stands for an end, and a beginning,” and as such, it represents the ongoing “heartbeat” of Native America."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en111",
      "id": "en111r",
      "role": "doc-noteref"
    }
  }, [_vm._v("107")])]), _vm._v(" It represents survival. “Rather than submit to the negative legacy of the massacre,” Michelle Pesantubbee observes, “native people have recast Wounded Knee as a symbol of resistance to historical and contemporary colonization. They have appropriated Wounded Knee as a powerful symbol for the cultural rebirth of the Lakota.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en112",
      "id": "en112r",
      "role": "doc-noteref"
    }
  }, [_vm._v("108")])])]), _vm._v(" "), _c('p', [_vm._v("The fact of Native American resilience, including the pragmatic adaptations that Indians made of white Christianity, is fundamental to understanding white American anxiety about race. Resilience has meant that Indians have survived as Indians: they are not a “vanished race.” That reality reminds Americans of Indian presence that increasingly is visible—and not just to those who visit casinos or engage in debates about their legal status. Indian survival is a witnessing both of resilience and of near erasure by whites. As much as Americans may wish to forget Indians, they are prompted to remember them because of Native American survivance. The fact that, moreover, Native Americans adapted Christianity to suit the conditions of their survivance is more than just a footnote to that reality. For white Americans who have embraced a comparatively rigid Christian orthodoxy over several centuries, it has been a signal of something troubling about Indians, namely, that they both are and are not Christians. They are religious kin but equally not kin.")])]), _vm._v(" "), _c('section', [_c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ah0104"
    }
  }, [_vm._v("The Situation of the Scholar")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("In this book I discuss relations between white Christians and both Native Americans and African Americans. As a white scholar steeped in Western conceptualizations of academic enterprise, I recognize that I speak from an impure positioning when undertaking such a project. I do not presume to objectively define the experiences of Indians or Blacks. Nor do I intend to intrude on the authority of Indian or Black writers in broaching an interpretation of a violent American historical past and its legacies in the present. My "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "31",
      "epub:type": "pagebreak",
      "id": "p31",
      "role": "doc-pagebreak"
    }
  }), _vm._v("perspective as a researcher, moreover, is in some measure influenced by my lifelong diet of historical and theoretical literature, which occasionally has rested on inapposite assumptions regarding colonial subalterns or subjected populations.")]), _vm._v(" "), _c('p', [_vm._v("In the mid-twentieth century, the French psychiatrist Frantz Fanon resigned his hospital position treating Algerian torture victims, reporting that he found that the therapeutic practice he had learned in France made little sense in the context of colonial Africa. The therapeutics of the West, in other words, were not easily fitted to a colonial world where the political and social predicaments of the colonized framed self and identity differently than did the culture of the colonizer."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en113",
      "id": "en113r",
      "role": "doc-noteref"
    }
  }, [_vm._v("109")])]), _vm._v(" In subsequent decades, the core claim of that argument was progressively extended and sharpened by Indigenous writers, and applied to the enterprise of research itself. By the end of the century the Maori scholar Linda Tuhiwai Smith had articulated, in "), _c('i', [_vm._v("Decolonizing Methodologies")]), _vm._v(" (1999), an approach to the study of Indigenous communities that rejected research incursions by non-Indigenous scholars, who, according to Smith, were chained to categories and methods that were so Eurocentrically charged as to blind those researchers to the realities of indigenes’ lives. For Smith, “the word research is probably one of the dirtiest words in the indigenous world’s vocabulary.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en114",
      "id": "en114r",
      "role": "doc-noteref"
    }
  }, [_vm._v("110")])]), _vm._v(" In the United States, such a view, while finding a measure of traction among theorists and ethnographers who previously had warned about the research risk of desubjectification, has been visible largely in its application to the practical agenda of indigenizing the academy."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en115",
      "id": "en115r",
      "role": "doc-noteref"
    }
  }, [_vm._v("111")])])]), _vm._v(" "), _c('p', [_vm._v("Academics’ thoughtfulness about the means and ends of research on colonialism, and, as I will discuss in the next chapter, about the enduring residuum of colonialism, constitutes a part of the broader “ethical turn” in academic writing since the 1980s. That turn has been felt in many disciplines, and with regard to academic investigation of many topics. It includes reflection on the position of the scholar and especially on privileged situations of scholars in their investigations of historical and cultural conflict.")]), _vm._v(" "), _c('p', [_vm._v("One way of assaying such positionality is to draw on an approach suggesting how persons—scholars or not—can be “beneficiaries” in the sense that their comfort and security rely on the vassalage and discomfiture of others. More importantly for researchers, it is the discourse of the beneficiaries that positions them in relation to those over whom they have an advantage. Writing as an intellectual addressing intellectuals, Bruce Robbins recognizes his own entanglements with inequities of power worldwide that erase the tracks back to the distressed labor that delivers commodities to him and many others. He asks: “Who is a beneficiary?” and answers: “You are, probably.” In other words, in aiming to cancel the gravity of a compromised discourse that "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "32",
      "epub:type": "pagebreak",
      "id": "p32",
      "role": "doc-pagebreak"
    }
  }), _vm._v("potentially distorts our perceptions of our research subjects, we look for offenders, and “the target has to include ourselves.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en116",
      "id": "en116r",
      "role": "doc-noteref"
    }
  }, [_vm._v("112")])])]), _vm._v(" "), _c('p', [_vm._v("A related articulation of the problem of the situated scholar is Michael Rothberg’s notion of the “implicated subject.” Developed out of Rothberg’s professional practice as a literature scholar and his particular interest in the Holocaust and genocide, his broaching of the term “implicated subject” bears the marks of the debates that have been churning within that field for decades. For Rothberg, the categories of victim, perpetrator, and bystander are largely artifacts of a twentieth-century project to interpret the Holocaust, and have less applicability to the topic of the colony and postcolony, which has so impressively aroused the interest of scholars in recent decades. He offers “implicated subject” as a term that he believes more accurately captures the complex web of relationships, with their ambiguities, reversals, and contradictions, of communities that stand in fraught relationships with each other. For Rothberg, "), _c('i', [_vm._v("victim")]), _vm._v(", then, is a desubjectifying term, just as is "), _c('i', [_vm._v("perpetrator")]), _vm._v(". And while he does not advocate a dismissal of issues of justice and reparation, he pleads for a more cosmopolitan and generic understanding of the conditions of suffering and violence, and the roles of those actors who are in one way or another, directly or indirectly, embedded in them. When he writes that he intends to examine the role of persons who “occupy positions aligned with power and privilege without being themselves directly agents of harm,” he reiterates to some extent the concerns of Robbins, but he frames his theory more in terms of a language that responds directly to issues of oppression that is purposeful and violent, and often involves the state."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en117",
      "id": "en117r",
      "role": "doc-noteref"
    }
  }, [_vm._v("113")])])]), _vm._v(" "), _c('p', [_vm._v("In thinking about the situatedness of the scholar, it is useful to recognize that Robbins and Rothberg, and a number of other theorists in different fields who have forayed in the same direction, center their critique on positionality that goes unrecognized—on scholarly unfamiliarity with legacy, benefit, implication, and participation. Such critiques repeatedly force the issue of the purpose of scholarship, and in the context of the ethical turn, that purpose is sometimes writ large as a matter of restorative and even, in some instances, retributive justice. The issue has been especially crucial to academic debates about the study of trauma, including mass trauma such as genocides, the structural violence of the postcolony, and transmitted psychological harm of traumatic violence. But there are other reasons to think about benefit and suffering. A potential case for reparations is not the only reason.")]), _vm._v(" "), _c('p', [_vm._v("Investigative pathways and themes generated within the broader Western and largely white scholarly literature of trauma and its representation—which, as we shall see, overlap in significant ways with writing by Native Americans and African Americans about their own suffering—in some measure "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "33",
      "epub:type": "pagebreak",
      "id": "p33",
      "role": "doc-pagebreak"
    }
  }), _vm._v("have conditioned discussion about how academics approach the lives of those about whom they write. There exists a likelihood that the subsequent compromised “recovery of the voices of traumatized testifiers and texts may be at the expense of those for whom trauma criticism claims to speak.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicorrigan0016#en118",
      "id": "en118r",
      "role": "doc-noteref"
    }
  }, [_vm._v("114")])]), _vm._v(" In other words, how does the historian negotiate the felt duty to describe the genocidal trauma of others while avoiding burying the subjectivities of the traumatized beneath a Western discourse likely to present problems of analytical and epistemological fit?")]), _vm._v(" "), _c('p', [_vm._v("And just as crucially, how does the white historian, as an inheritor of an anxiety about trauma that took place in the distant past, find a pathway to a standpoint that, on balance, yields compassionate and reflexive perspective alongside critical and analytical precision? White anxiety is a crucial but often overlooked part of the tangle of trauma born of violence perpetrated by whites against Native Americans and African Americans. It is an anxiety with a long arc. It is a racial anxiety, specifically constituted by a process of remembering and forgetting, of erasing and reengaging, a violent past. It is the anxiety of Jake Chansley’s charade. And it is the anxiety of the other January 6 insurrectionists, with their prayers, crosses, and Confederate flags.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46ae066e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-corrigan-0008.vue
// module id = 75
// module chunks = 0